import { gql } from '@apollo/client';
const REMOVE_PROJECTION = gql `
  mutation RemoveProjection($modelSpecificationProjectionId: ID!) {
    removeModelSpecificationProjection(
      modelSpecificationProjectionId: $modelSpecificationProjectionId
    ) {
      removed
    }
  }
`;
export default REMOVE_PROJECTION;
